const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcommerceRetail(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 460.918 399.841",
    style: {
      enableBackground: "new 0 0 460.918 399.841"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#1FC4F4"
    },
    width: 460.918,
    height: 399.841
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#C3DAE6"
    },
    cx: 237.629,
    cy: 297.238,
    rx: 183.953,
    ry: 13.069
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DAE6"
    },
    d: "M106.742,340.728c0,2.625,11.205,4.754,25.023,4.754c13.82,0,25.021-2.128,25.021-4.754 c0-2.625-11.201-4.754-25.021-4.754C117.947,335.974,106.742,338.102,106.742,340.728z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C3DAE6"
    },
    d: "M311.271,343.31c0,2.625,11.205,4.754,25.023,4.754c13.82,0,25.021-2.129,25.021-4.754 c0-2.625-11.201-4.754-25.021-4.754C322.476,338.556,311.271,340.685,311.271,343.31z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.86,
    y: 118.312,
    style: {
      fill: "#FEC450"
    },
    width: 240.928,
    height: 178.927
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.86,
    y: 118.312,
    style: {
      fill: "#F0516F"
    },
    width: 240.928,
    height: 33.459
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M295.714,135.042c0,3.358-2.729,6.083-6.088,6.083c-3.358,0-6.082-2.725-6.082-6.083 c0-3.36,2.724-6.087,6.082-6.087C292.985,128.955,295.714,131.682,295.714,135.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M314.422,135.042c0,3.358-2.724,6.083-6.083,6.083c-3.363,0-6.084-2.725-6.084-6.083 c0-3.36,2.721-6.087,6.084-6.087C311.698,128.955,314.422,131.682,314.422,135.042z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M332.978,135.042c0,3.358-2.725,6.083-6.083,6.083s-6.084-2.725-6.084-6.083 c0-3.36,2.726-6.087,6.084-6.087S332.978,131.682,332.978,135.042z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.122,
    y: 247.949,
    style: {
      fill: "#FFFFFF"
    },
    width: 167.058,
    height: 22.654
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.122,
    y: 277.031,
    style: {
      fill: "#FFFFFF"
    },
    width: 167.058,
    height: 8.572
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 217.128,
    y: 251.518,
    style: {
      fill: "#F0516F"
    },
    width: 34.949,
    height: 15.518
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M226.494,263.769v-9.062h2.045c0.539,0,1.025,0.142,1.459,0.426 c0.371,0.241,0.637,0.614,0.795,1.12c0.088,0.27,0.131,0.59,0.131,0.961c0,0.607-0.162,1.094-0.484,1.46 c-0.135,0.154-0.295,0.272-0.477,0.354c0.303,0.115,0.561,0.344,0.773,0.687c0.139,0.231,0.242,0.53,0.311,0.896 c0.033,0.188,0.051,0.397,0.051,0.628c0,0.573-0.109,1.06-0.326,1.46c-0.168,0.313-0.406,0.564-0.715,0.752 c-0.348,0.212-0.691,0.318-1.033,0.318H226.494z M227.967,258.407h0.572c0.424,0,0.707-0.207,0.852-0.622 c0.053-0.154,0.08-0.344,0.08-0.571c0-0.375-0.092-0.66-0.275-0.853c-0.168-0.178-0.387-0.268-0.656-0.268h-0.572V258.407z  M227.967,262.418h0.572c0.463,0,0.783-0.239,0.961-0.716c0.063-0.164,0.094-0.352,0.094-0.563 c0-0.506-0.096-0.875-0.289-1.105c-0.174-0.212-0.43-0.318-0.766-0.318h-0.572V262.418z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M234.428,263.87c-0.602,0-1.113-0.209-1.531-0.628c-0.42-0.419-0.629-0.928-0.629-1.525v-7.002 h1.336v6.987c0,0.217,0.078,0.401,0.232,0.553c0.154,0.151,0.338,0.227,0.555,0.227c0.217,0,0.402-0.076,0.555-0.227 c0.15-0.152,0.227-0.336,0.227-0.553v-6.987h1.424v7.002c0,0.607-0.213,1.118-0.637,1.532 C235.535,263.663,235.025,263.87,234.428,263.87z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M239.508,259.975l-1.828-5.268h1.502l1.012,3.251l1.006-3.251h1.51l-1.836,5.268v3.794h-1.365 V259.975z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B62A9",
      strokeWidth: 1.1251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 273.933,
    y1: 252.629,
    x2: 272.896,
    y2: 256.301
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B62A9",
      strokeWidth: 1.1251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 258.888,
    y1: 267.143,
    x2: 262.474,
    y2: 265.846
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B62A9",
      strokeWidth: 1.1251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 258.772,
    y1: 260.975,
    x2: 262.588,
    y2: 260.975
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B62A9",
      strokeWidth: 1.1251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 267.836,
    y1: 251.518,
    x2: 267.836,
    y2: 255.333
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#1B62A9",
      strokeWidth: 1.1251,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    x1: 260.681,
    y1: 254.087,
    x2: 263.571,
    y2: 256.578
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#1B62A9"
    },
    points: "277.308,276.288 282.69,271.364 274.196,262.079 277.834,258.751 265.202,257.648  265.175,270.328 268.814,267.001  "
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 151.423,
    y: 162.471,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.773,
    height: 32.145
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.482,
    y: 162.471,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.774,
    height: 32.145
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.45,
    y: 162.471,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.775,
    height: 32.145
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#939598"
    },
    d: "M190.238,181.921h-0.003c-0.086-1.21-0.829-2.98-3.308-3.487 c-0.802-0.164-1.873-0.338-3.114-0.537c-3.443-0.558-8.103-1.313-9.938-2.396v-0.393c1.069-0.237,1.876-1.198,1.876-2.334 c0-1.318-1.072-2.391-2.392-2.391c-0.717,0-1.387,0.317-1.844,0.87l0.758,0.626c0.269-0.325,0.664-0.512,1.086-0.512 c0.776,0,1.406,0.631,1.406,1.406c0,0.767-0.622,1.397-1.389,1.407l-0.485,0.006v1.274c-1.784,1.105-6.52,1.872-10.007,2.436 c-1.241,0.199-2.314,0.373-3.116,0.537c-2.477,0.507-3.222,2.277-3.308,3.487l-0.006,0.983h33.782V181.921z M159.966,179.398 c0.784-0.16,1.848-0.332,3.077-0.53c3.722-0.603,8.304-1.346,10.308-2.54c2,1.194,6.584,1.938,10.306,2.54 c1.229,0.198,2.292,0.37,3.075,0.53c2.023,0.414,2.437,1.802,2.512,2.523h-31.79C157.52,181.2,157.925,179.814,159.966,179.398z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M313.814,188.265c0,0-0.001,0.001-0.004,0.001c-0.014-0.263-0.443-6.494-11.949-6.522 c0,0-8.488-0.678-10.357-14.124c0,0-6.982-0.65-8.185,6.064c-0.326,1.811-0.268,2.839,0.602,5.301 c0.853,2.415,0.669,10.319,0.669,10.319h1.89l0.008-9.293c0,0,6.5,2.797,10.693,9.369c1.003,1.571,11.713,1.14,16.603-0.422 C313.782,188.957,313.88,188.717,313.814,188.265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C63F5B"
    },
    d: "M291.503,167.619c0,0,0.331-0.087,1.318,1.692c2.416,4.347,4.455,9.93,11.926,12.587 c0,0-3.876,1.515-7.938-1.965C294.317,177.796,291.013,172.72,291.503,167.619z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.588,
    y: 189.247,
    style: {
      fill: "#C63F5B"
    },
    width: 1.897,
    height: 0.736
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19599B"
    },
    d: "M233.426,175.781c0,0,3.121-9.88,7.022-9.374c1.775,0.23,4.77,2.032,3.9,6.009 c-0.445,2.03-2.893,3.552-9.492,5.064L233.426,175.781z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#124881"
    },
    d: "M234.358,175.436c0,0,3.039-8.946,6.058-7.425c0.791,0.397,0.815,1.936-1.502,4.563 C235.964,175.923,234.358,175.436,234.358,175.436z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#19599B"
    },
    d: "M233.974,175.824c0,0-3.02-9.912-6.922-9.447c-1.779,0.211-4.794,1.981-3.968,5.968 c0.422,2.034,2.855,3.582,9.436,5.163L233.974,175.824z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#124881"
    },
    d: "M233.041,175.47c0,0-2.944-8.977-5.981-7.488c-0.793,0.388-0.832,1.927,1.456,4.578 C231.431,175.939,233.041,175.47,233.041,175.47z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 219.996,
    y: 178.983,
    style: {
      fill: "#1D9AD6"
    },
    width: 27.588,
    height: 12.39
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.21,
    y: 175.99,
    style: {
      fill: "#1B62A9"
    },
    width: 29.16,
    height: 3.963
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M238.079,180.322l-2.145-1.494h-3.088l-2.187,1.504v8.884h7.419V180.322z M234.384,180.616 c-0.305,0-0.552-0.247-0.552-0.552c0-0.305,0.247-0.552,0.552-0.552s0.552,0.247,0.552,0.552 C234.936,180.369,234.689,180.616,234.384,180.616z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M231.93,184.092c0-0.221,0.023-0.414,0.07-0.577c0.047-0.164,0.113-0.3,0.199-0.409 c0.086-0.108,0.188-0.189,0.305-0.242c0.119-0.053,0.25-0.08,0.393-0.08c0.143,0,0.273,0.027,0.393,0.08 c0.117,0.053,0.221,0.134,0.305,0.242c0.086,0.109,0.152,0.245,0.199,0.409c0.047,0.164,0.07,0.356,0.07,0.577 c0,0.219-0.023,0.411-0.07,0.574c-0.047,0.164-0.113,0.3-0.199,0.409c-0.084,0.108-0.188,0.189-0.305,0.244 c-0.119,0.054-0.25,0.081-0.393,0.081c-0.143,0-0.273-0.027-0.393-0.081c-0.117-0.055-0.219-0.136-0.305-0.244 c-0.086-0.109-0.152-0.245-0.199-0.409C231.953,184.503,231.93,184.311,231.93,184.092z M233.207,184.092 c0-0.112-0.006-0.216-0.016-0.311c-0.01-0.094-0.027-0.176-0.051-0.244c-0.023-0.068-0.055-0.122-0.096-0.161 c-0.039-0.039-0.088-0.059-0.148-0.059c-0.061,0-0.109,0.02-0.148,0.059c-0.039,0.039-0.072,0.093-0.096,0.161 c-0.023,0.068-0.041,0.15-0.051,0.244c-0.01,0.095-0.016,0.198-0.016,0.311c0,0.11,0.006,0.213,0.016,0.309 c0.01,0.095,0.027,0.177,0.051,0.246c0.023,0.068,0.057,0.122,0.096,0.161c0.039,0.039,0.088,0.059,0.148,0.059 c0.061,0,0.109-0.02,0.148-0.059c0.041-0.039,0.072-0.093,0.096-0.161c0.023-0.068,0.041-0.15,0.051-0.246 C233.201,184.306,233.207,184.203,233.207,184.092z M236.01,183.056l-2.941,3.942l-0.393-0.301l2.943-3.943L236.01,183.056z  M234.828,185.629c0-0.221,0.023-0.413,0.072-0.577c0.047-0.163,0.113-0.3,0.197-0.408c0.086-0.108,0.188-0.189,0.307-0.243 c0.119-0.053,0.25-0.08,0.393-0.08c0.143,0,0.273,0.027,0.391,0.08c0.119,0.053,0.221,0.134,0.307,0.243 c0.086,0.108,0.152,0.245,0.199,0.408c0.047,0.164,0.07,0.357,0.07,0.577c0,0.219-0.023,0.411-0.07,0.574 c-0.047,0.164-0.113,0.3-0.199,0.409c-0.086,0.108-0.188,0.19-0.307,0.244c-0.117,0.054-0.248,0.082-0.391,0.082 c-0.143,0-0.273-0.027-0.393-0.082c-0.119-0.054-0.221-0.136-0.307-0.244c-0.084-0.108-0.15-0.245-0.197-0.409 C234.852,186.04,234.828,185.849,234.828,185.629z M236.107,185.629c0-0.112-0.006-0.216-0.016-0.31 c-0.01-0.095-0.027-0.176-0.051-0.244c-0.025-0.068-0.057-0.122-0.096-0.162c-0.039-0.039-0.088-0.059-0.148-0.059 c-0.061,0-0.111,0.02-0.15,0.059c-0.039,0.039-0.07,0.093-0.094,0.162c-0.025,0.068-0.041,0.149-0.051,0.244 c-0.012,0.094-0.016,0.198-0.016,0.31c0,0.111,0.004,0.214,0.016,0.309c0.01,0.096,0.025,0.177,0.051,0.246 c0.023,0.068,0.055,0.122,0.094,0.162c0.039,0.039,0.09,0.059,0.15,0.059c0.061,0,0.109-0.02,0.148-0.059 c0.039-0.04,0.07-0.093,0.096-0.162c0.023-0.068,0.041-0.15,0.051-0.246C236.102,185.843,236.107,185.74,236.107,185.629z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC450"
    },
    d: "M234.369,180.618c-0.13,0-0.233-0.06-0.233-0.06v-4.864c0-0.129,0.104-0.233,0.233-0.233 c0.129,0,0.233,0.104,0.233,0.233v4.877C234.536,180.605,234.498,180.618,234.369,180.618z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC450"
    },
    d: "M294.93,181.579l-2.144-1.494h-3.087l-2.188,1.503v8.885h7.418V181.579z M291.235,181.873 c-0.305,0-0.553-0.247-0.553-0.552s0.248-0.552,0.553-0.552c0.306,0,0.552,0.247,0.552,0.552S291.541,181.873,291.235,181.873z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M288.781,185.349c0-0.221,0.023-0.413,0.07-0.577c0.047-0.164,0.113-0.3,0.199-0.409 c0.086-0.108,0.188-0.189,0.305-0.242c0.119-0.053,0.25-0.08,0.392-0.08c0.143,0,0.274,0.027,0.393,0.08 c0.117,0.053,0.221,0.134,0.305,0.242c0.086,0.109,0.152,0.245,0.199,0.409s0.07,0.356,0.07,0.577 c0,0.219-0.023,0.411-0.07,0.574c-0.047,0.164-0.113,0.3-0.199,0.409c-0.084,0.108-0.188,0.189-0.305,0.244 c-0.119,0.054-0.25,0.081-0.393,0.081c-0.142,0-0.273-0.027-0.392-0.081c-0.117-0.055-0.219-0.136-0.305-0.244 c-0.086-0.109-0.152-0.245-0.199-0.409C288.805,185.759,288.781,185.568,288.781,185.349z M290.059,185.349 c0-0.112-0.006-0.216-0.016-0.311c-0.01-0.094-0.027-0.176-0.051-0.244c-0.023-0.068-0.055-0.122-0.096-0.161 c-0.039-0.039-0.088-0.059-0.149-0.059c-0.06,0-0.109,0.02-0.148,0.059c-0.039,0.039-0.072,0.093-0.096,0.161 c-0.023,0.068-0.041,0.15-0.051,0.244c-0.01,0.095-0.016,0.198-0.016,0.311c0,0.11,0.006,0.213,0.016,0.309 c0.01,0.095,0.027,0.177,0.051,0.246c0.023,0.068,0.057,0.122,0.096,0.161c0.039,0.039,0.088,0.059,0.148,0.059 c0.061,0,0.109-0.02,0.149-0.059c0.041-0.039,0.072-0.093,0.096-0.161c0.023-0.068,0.041-0.15,0.051-0.246 C290.053,185.562,290.059,185.459,290.059,185.349z M292.861,184.312l-2.941,3.942l-0.393-0.301l2.943-3.943L292.861,184.312z  M291.68,186.886c0-0.221,0.023-0.413,0.072-0.577c0.047-0.164,0.113-0.3,0.197-0.408c0.086-0.108,0.188-0.189,0.307-0.243 c0.119-0.053,0.25-0.08,0.393-0.08c0.143,0,0.273,0.027,0.391,0.08c0.119,0.053,0.221,0.134,0.307,0.243 s0.152,0.245,0.199,0.408c0.047,0.164,0.07,0.356,0.07,0.577c0,0.219-0.023,0.411-0.07,0.574 c-0.047,0.164-0.113,0.3-0.199,0.409s-0.188,0.19-0.307,0.244c-0.117,0.054-0.248,0.082-0.391,0.082 c-0.143,0-0.273-0.027-0.393-0.082c-0.119-0.054-0.221-0.136-0.307-0.244c-0.084-0.108-0.15-0.245-0.197-0.409 C291.703,187.296,291.68,187.105,291.68,186.886z M292.959,186.886c0-0.112-0.006-0.216-0.016-0.31 c-0.01-0.095-0.027-0.176-0.051-0.244c-0.025-0.068-0.057-0.122-0.096-0.162c-0.039-0.039-0.088-0.059-0.148-0.059 c-0.061,0-0.111,0.02-0.15,0.059c-0.039,0.04-0.07,0.093-0.094,0.162c-0.025,0.068-0.041,0.15-0.051,0.244 c-0.012,0.094-0.016,0.198-0.016,0.31c0,0.111,0.004,0.214,0.016,0.309c0.01,0.096,0.025,0.177,0.051,0.246 c0.023,0.068,0.055,0.122,0.094,0.162c0.039,0.039,0.09,0.059,0.15,0.059c0.061,0,0.109-0.02,0.148-0.059 c0.039-0.04,0.07-0.093,0.096-0.162c0.023-0.068,0.041-0.15,0.051-0.246C292.953,187.1,292.959,186.997,292.959,186.886z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M291.222,181.875c-0.13,0-0.234-0.061-0.234-0.061v-4.863c0-0.129,0.104-0.233,0.234-0.233 c0.128,0,0.232,0.104,0.232,0.233v4.877C291.388,181.862,291.35,181.875,291.222,181.875z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 152.169,
    y: 207.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.774,
    height: 32.144
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.25,
    y: 207.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.773,
    height: 32.144
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.293,
    y: 207.442,
    style: {
      fill: "#FFFFFF"
    },
    width: 43.774,
    height: 32.144
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 180.257,
    y: 213.683,
    transform: "matrix(0.6293 -0.7772 0.7772 0.6293 -101.2423 223.5712)",
    style: {
      fill: "#FEC450"
    },
    width: 6.939,
    height: 8.45
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.667,
    y: 214.438,
    transform: "matrix(0.7771 -0.6294 0.6294 0.7771 -100.8371 151.0891)",
    style: {
      fill: "#FEC450"
    },
    width: 8.449,
    height: 6.94
  }), /*#__PURE__*/React.createElement("rect", {
    x: 163.959,
    y: 212.553,
    style: {
      fill: "#FEC450"
    },
    width: 18.66,
    height: 24.074
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAA73F"
    },
    points: "168.911,212.553 173.405,216.2 177.903,212.553  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M225.617,237.079h16.513c-0.248-1.913-0.229-5.916,1.696-13.567 c1.683-4.135,1.462-12.622,1.462-12.622h-1.747c0.332,3.371-0.317,6.588-0.566,7.657c-0.977-1.254-2.501-1.946-4.21-2.063 c-1.741-0.118-4.109,0.174-4.924,2.076c-0.815-1.902-3.209-2.163-4.887-2.076c-1.878,0.096-3.527,0.974-4.479,2.441 c-0.002-0.001-0.002-0.003-0.002-0.003s-1.064-3.901-0.658-8.033h-1.748c0,0-0.005,8.007,1.688,12.135 C223.759,223.03,226.277,231.942,225.617,237.079z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB049"
    },
    d: "M296.39,218.706c0,0-3.543-6.492-1.354-8.249c0.999-0.8,3.407-1.449,5.025,0.964 c0.826,1.232,0.397,3.246-2.089,7.39L296.39,218.706z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E29839"
    },
    d: "M296.674,218.058c0,0-3.103-5.989-0.825-6.793c0.594-0.21,1.398,0.54,1.603,3.031 C297.718,217.47,296.674,218.058,296.674,218.058z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB049"
    },
    d: "M297.384,218.011c0,0,2.228-7.052,5.013-6.691c1.267,0.164,3.403,1.451,2.783,4.289 c-0.317,1.45-2.063,2.536-6.774,3.615L297.384,218.011z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E29839"
    },
    d: "M298.05,217.766c0,0,2.168-6.386,4.325-5.301c0.564,0.283,0.579,1.383-1.073,3.258 C299.196,218.112,298.05,217.766,298.05,217.766z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFB049"
    },
    d: "M296.955,218.21c0,0-2.155-7.076-4.941-6.744c-1.269,0.151-3.42,1.416-2.829,4.261 c0.3,1.451,2.036,2.557,6.734,3.686L296.955,218.21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E29839"
    },
    d: "M296.293,217.957c0,0-2.103-6.409-4.271-5.346c-0.567,0.277-0.594,1.375,1.038,3.269 C295.142,218.292,296.293,217.957,296.293,217.957z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 288.611,
    y: 219.793,
    style: {
      fill: "#F0516F"
    },
    width: 16.917,
    height: 16.058
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.875,
    y: 218.341,
    style: {
      fill: "#FEC450"
    },
    width: 18.392,
    height: 2.904
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M181.612,217.414l-2.143-1.494h-3.088l-2.188,1.504v8.884h7.418V217.414z M177.918,217.708 c-0.305,0-0.552-0.246-0.552-0.551c0-0.306,0.247-0.553,0.552-0.553c0.305,0,0.552,0.247,0.552,0.553 C178.47,217.462,178.223,217.708,177.918,217.708z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M175.463,221.184c0-0.221,0.023-0.414,0.07-0.577c0.049-0.163,0.115-0.3,0.199-0.409 c0.086-0.108,0.188-0.189,0.307-0.242c0.119-0.053,0.25-0.08,0.393-0.08c0.143,0,0.273,0.027,0.391,0.08 c0.119,0.053,0.221,0.134,0.307,0.242c0.086,0.109,0.152,0.245,0.199,0.409c0.047,0.164,0.07,0.356,0.07,0.577 c0,0.219-0.023,0.411-0.07,0.574c-0.047,0.164-0.113,0.3-0.199,0.409c-0.086,0.108-0.188,0.189-0.307,0.244 c-0.117,0.054-0.248,0.081-0.391,0.081c-0.143,0-0.273-0.027-0.393-0.081c-0.119-0.055-0.221-0.136-0.307-0.244 c-0.084-0.109-0.15-0.245-0.199-0.409C175.486,221.595,175.463,221.403,175.463,221.184z M176.742,221.184 c0-0.112-0.006-0.216-0.016-0.311c-0.01-0.094-0.027-0.176-0.051-0.244c-0.025-0.068-0.057-0.122-0.096-0.161 c-0.039-0.039-0.09-0.059-0.148-0.059c-0.061,0-0.111,0.02-0.15,0.059c-0.039,0.039-0.07,0.093-0.094,0.161 c-0.025,0.068-0.043,0.15-0.053,0.244c-0.01,0.095-0.014,0.198-0.014,0.311c0,0.11,0.004,0.213,0.014,0.309 c0.01,0.095,0.027,0.177,0.053,0.246c0.023,0.068,0.055,0.122,0.094,0.161c0.039,0.039,0.09,0.059,0.15,0.059 c0.059,0,0.109-0.02,0.148-0.059c0.039-0.039,0.07-0.093,0.096-0.161c0.023-0.068,0.041-0.15,0.051-0.246 C176.736,221.398,176.742,221.294,176.742,221.184z M179.545,220.148l-2.941,3.942l-0.393-0.301l2.941-3.943L179.545,220.148z  M178.363,222.721c0-0.221,0.023-0.413,0.07-0.577c0.047-0.163,0.113-0.3,0.199-0.408c0.086-0.108,0.188-0.189,0.307-0.243 c0.117-0.053,0.248-0.08,0.391-0.08c0.143,0,0.273,0.027,0.393,0.08c0.119,0.053,0.221,0.134,0.307,0.243 c0.084,0.108,0.15,0.245,0.197,0.408c0.049,0.164,0.072,0.357,0.072,0.577c0,0.219-0.023,0.411-0.072,0.574 c-0.047,0.164-0.113,0.3-0.197,0.409c-0.086,0.108-0.188,0.19-0.307,0.244c-0.119,0.054-0.25,0.082-0.393,0.082 c-0.143,0-0.273-0.027-0.391-0.082c-0.119-0.054-0.221-0.136-0.307-0.244c-0.086-0.108-0.152-0.245-0.199-0.409 C178.387,223.132,178.363,222.94,178.363,222.721z M179.641,222.721c0-0.112-0.004-0.216-0.016-0.31 c-0.01-0.095-0.025-0.176-0.051-0.244c-0.023-0.068-0.055-0.122-0.094-0.162c-0.039-0.039-0.09-0.059-0.15-0.059 c-0.061,0-0.109,0.02-0.148,0.059c-0.039,0.04-0.07,0.093-0.096,0.162c-0.023,0.068-0.041,0.149-0.051,0.244 c-0.01,0.094-0.016,0.198-0.016,0.31c0,0.111,0.006,0.214,0.016,0.309c0.01,0.096,0.027,0.177,0.051,0.246 c0.025,0.068,0.057,0.122,0.096,0.162c0.039,0.039,0.088,0.059,0.148,0.059c0.061,0,0.111-0.02,0.15-0.059 c0.039-0.04,0.07-0.093,0.094-0.162c0.025-0.068,0.041-0.15,0.051-0.246C179.637,222.935,179.641,222.832,179.641,222.721z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M177.903,217.71c-0.129,0-0.232-0.06-0.232-0.06v-4.864c0-0.129,0.104-0.233,0.232-0.233 c0.129,0,0.233,0.104,0.233,0.233v4.877C178.07,217.697,178.032,217.71,177.903,217.71z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC450"
    },
    d: "M246.672,223.648l-2.384-1.661h-3.435l-2.433,1.672v9.883h8.251V223.648z M242.561,223.976 c-0.34,0-0.613-0.274-0.613-0.613s0.273-0.614,0.613-0.614c0.34,0,0.614,0.275,0.614,0.614S242.901,223.976,242.561,223.976z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M239.832,227.842c0-0.246,0.025-0.46,0.078-0.642c0.053-0.182,0.125-0.334,0.221-0.455 c0.096-0.121,0.209-0.21,0.34-0.27c0.133-0.059,0.277-0.089,0.438-0.089c0.158,0,0.303,0.03,0.436,0.089 c0.131,0.06,0.244,0.149,0.34,0.27c0.096,0.121,0.168,0.272,0.221,0.455c0.053,0.182,0.08,0.396,0.08,0.642 c0,0.244-0.027,0.456-0.08,0.639c-0.053,0.182-0.125,0.333-0.221,0.454c-0.096,0.121-0.209,0.211-0.34,0.271 c-0.133,0.061-0.277,0.091-0.436,0.091c-0.16,0-0.305-0.03-0.438-0.091c-0.131-0.06-0.244-0.151-0.34-0.271 c-0.096-0.121-0.168-0.272-0.221-0.454C239.857,228.299,239.832,228.086,239.832,227.842z M241.252,227.842 c0-0.126-0.004-0.24-0.016-0.346c-0.012-0.105-0.031-0.195-0.057-0.271c-0.027-0.076-0.063-0.136-0.105-0.179 c-0.045-0.044-0.1-0.065-0.166-0.065c-0.068,0-0.123,0.021-0.166,0.065c-0.045,0.044-0.08,0.104-0.105,0.179 c-0.027,0.076-0.047,0.167-0.059,0.271c-0.01,0.105-0.016,0.22-0.016,0.346c0,0.122,0.006,0.237,0.016,0.343 c0.012,0.107,0.031,0.198,0.059,0.273c0.025,0.076,0.061,0.136,0.105,0.18c0.043,0.043,0.098,0.065,0.166,0.065 c0.066,0,0.121-0.021,0.166-0.065c0.043-0.044,0.078-0.104,0.105-0.18c0.025-0.076,0.045-0.167,0.057-0.273 C241.248,228.08,241.252,227.965,241.252,227.842z M244.371,226.689l-3.273,4.386l-0.436-0.335l3.273-4.386L244.371,226.689z  M243.057,229.552c0-0.246,0.025-0.46,0.078-0.642c0.053-0.182,0.127-0.334,0.223-0.455c0.094-0.121,0.207-0.21,0.34-0.27 c0.131-0.059,0.277-0.088,0.436-0.088s0.305,0.029,0.436,0.088c0.133,0.06,0.246,0.15,0.34,0.27 c0.096,0.121,0.17,0.272,0.223,0.455c0.053,0.182,0.078,0.396,0.078,0.642c0,0.244-0.025,0.457-0.078,0.639 c-0.053,0.182-0.127,0.333-0.223,0.454c-0.094,0.121-0.207,0.211-0.34,0.272c-0.131,0.06-0.277,0.09-0.436,0.09 s-0.305-0.03-0.436-0.09c-0.133-0.061-0.246-0.151-0.34-0.272c-0.096-0.121-0.17-0.272-0.223-0.454 C243.082,230.009,243.057,229.796,243.057,229.552z M244.479,229.552c0-0.125-0.006-0.24-0.018-0.346 c-0.01-0.105-0.029-0.195-0.057-0.271c-0.027-0.076-0.063-0.136-0.105-0.179c-0.043-0.044-0.1-0.066-0.166-0.066 c-0.066,0-0.123,0.022-0.166,0.066c-0.043,0.043-0.078,0.104-0.105,0.179c-0.027,0.076-0.045,0.166-0.057,0.271 c-0.012,0.105-0.018,0.22-0.018,0.346c0,0.123,0.006,0.237,0.018,0.344c0.012,0.106,0.029,0.197,0.057,0.273 c0.027,0.076,0.063,0.136,0.105,0.18c0.043,0.044,0.1,0.065,0.166,0.065c0.066,0,0.123-0.022,0.166-0.065 c0.043-0.044,0.078-0.104,0.105-0.18c0.027-0.076,0.047-0.167,0.057-0.273C244.473,229.79,244.479,229.675,244.479,229.552z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M242.546,223.977c-0.144,0-0.26-0.066-0.26-0.066v-5.41c0-0.144,0.116-0.26,0.26-0.26 c0.144,0,0.26,0.116,0.26,0.26v5.425C242.731,223.964,242.689,223.977,242.546,223.977z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC450"
    },
    d: "M302.65,222.508l-1.837-1.28h-2.646l-1.875,1.288v7.615h6.357V222.508z M299.483,222.76 c-0.262,0-0.473-0.212-0.473-0.473c0-0.262,0.211-0.474,0.473-0.474s0.474,0.212,0.474,0.474 C299.957,222.548,299.745,222.76,299.483,222.76z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.379,225.739c0-0.189,0.021-0.355,0.06-0.495c0.041-0.141,0.098-0.257,0.172-0.35 c0.072-0.093,0.16-0.163,0.262-0.208c0.102-0.046,0.213-0.068,0.336-0.068c0.123,0,0.234,0.022,0.336,0.068 c0.102,0.045,0.19,0.115,0.262,0.208c0.074,0.093,0.131,0.21,0.17,0.35c0.041,0.14,0.063,0.305,0.063,0.495 c0,0.188-0.021,0.352-0.063,0.492c-0.039,0.141-0.096,0.257-0.17,0.35c-0.072,0.093-0.16,0.163-0.262,0.21 c-0.102,0.046-0.213,0.07-0.336,0.07c-0.123,0-0.234-0.023-0.336-0.07c-0.101-0.046-0.189-0.116-0.262-0.21 c-0.074-0.093-0.131-0.209-0.172-0.35C297.4,226.091,297.379,225.927,297.379,225.739z M298.475,225.739 c0-0.096-0.004-0.185-0.012-0.266c-0.01-0.081-0.023-0.15-0.045-0.209c-0.021-0.059-0.047-0.105-0.082-0.139 c-0.033-0.033-0.076-0.05-0.127-0.05c-0.053,0-0.094,0.017-0.129,0.05c-0.033,0.034-0.061,0.08-0.08,0.139 c-0.022,0.059-0.035,0.128-0.045,0.209c-0.008,0.081-0.012,0.17-0.012,0.266c0,0.095,0.004,0.183,0.012,0.265 c0.01,0.082,0.023,0.152,0.045,0.21c0.02,0.059,0.047,0.105,0.08,0.138c0.035,0.034,0.076,0.05,0.129,0.05 c0.051,0,0.094-0.017,0.127-0.05c0.035-0.034,0.061-0.08,0.082-0.138c0.021-0.059,0.035-0.129,0.045-0.21 C298.471,225.922,298.475,225.834,298.475,225.739z M300.877,224.851l-2.521,3.379l-0.336-0.258l2.521-3.379L300.877,224.851z  M299.865,227.057c0-0.189,0.02-0.354,0.061-0.495c0.041-0.141,0.098-0.257,0.17-0.35c0.074-0.093,0.162-0.163,0.264-0.208 c0.102-0.046,0.213-0.069,0.336-0.069c0.121,0,0.232,0.023,0.336,0.069c0.102,0.045,0.188,0.115,0.262,0.208 c0.072,0.093,0.129,0.21,0.17,0.35c0.041,0.14,0.061,0.305,0.061,0.495c0,0.188-0.02,0.352-0.061,0.492 c-0.041,0.14-0.098,0.257-0.17,0.35c-0.074,0.093-0.16,0.163-0.262,0.21c-0.103,0.046-0.215,0.069-0.336,0.069 c-0.123,0-0.234-0.023-0.336-0.069c-0.102-0.047-0.19-0.117-0.264-0.21c-0.072-0.093-0.129-0.21-0.17-0.35 C299.885,227.409,299.865,227.245,299.865,227.057z M300.961,227.057c0-0.097-0.004-0.185-0.014-0.266 c-0.008-0.081-0.023-0.151-0.043-0.21c-0.021-0.059-0.049-0.104-0.082-0.138c-0.033-0.034-0.076-0.05-0.127-0.05 c-0.053,0-0.096,0.017-0.129,0.05c-0.033,0.034-0.061,0.079-0.082,0.138c-0.02,0.059-0.035,0.129-0.043,0.21 c-0.01,0.081-0.014,0.169-0.014,0.266c0,0.095,0.004,0.183,0.014,0.265c0.008,0.082,0.023,0.152,0.043,0.21 c0.021,0.059,0.049,0.105,0.082,0.139c0.033,0.033,0.076,0.05,0.129,0.05c0.051,0,0.094-0.017,0.127-0.05 c0.033-0.034,0.061-0.08,0.082-0.139c0.02-0.058,0.035-0.128,0.043-0.21C300.957,227.24,300.961,227.152,300.961,227.057z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M299.472,222.761c-0.111,0-0.201-0.051-0.201-0.051v-4.169c0-0.11,0.09-0.2,0.201-0.2 c0.11,0,0.199,0.09,0.199,0.2v4.18C299.614,222.75,299.582,222.761,299.472,222.761z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M143.464,342.438c2.844-0.893,1.9-3.979,0.879-3.989c-0.755-0.009-1.637-0.025-2.717-0.025 c-1.599,0-2.733-0.739-2.629-0.739h-4.472c-0.112,0.091-0.212,0.262-0.271,0.564l-0.018,4.19H143.464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M131.196,276.595c0.145,7.249,2.727,55.663,2.727,61.089h5.475c0,0,2.867-52.978,3.074-61.089 H131.196z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M131.561,342.438c2.847-0.893,1.905-3.979,0.876-3.989c-0.749-0.009-1.631-0.025-2.713-0.025 c-1.593,0-2.729-0.739-2.633-0.739h-4.466c-0.112,0.091-0.216,0.262-0.269,0.564l-0.018,4.19H131.561z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M120.91,276.595c0.042,6.092,1.147,55.581,1.147,61.089h5.665c0,0,4.188-52.783,4.905-61.036 L120.91,276.595z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M143.688,276.828c0-0.082,0.784-31.377-3.854-43.01c-0.782-1.955-1.695-3.911-3.539-4.47 c-1.622-0.49-3.506-1.104-4.575-1.104c-2.377,0-4.028,1.906-7.016,6.061c-5.051,7.014-4.924,30.545-4.91,42.522H143.688z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M131.772,222.352v6.1c0,1.171,2.156,2.117,3.262,2.117c0.76,0,1.189-0.412,1.189-2.117v-4.984 L131.772,222.352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M140.382,219.48c-0.378-0.738-0.547-1.569-0.615-2.326c0.007-0.045,0.009-0.074,0.009-0.074 c0.11-0.988,0.867-2.484,0.606-3.2c-0.673-1.854-3.339-2.882-5.929-3.164c-3.272-0.356-5.736,1.733-6.246,6.423 c-0.267,2.425,1.247,5.042,2.971,5.545c1.296,0.376,3.798,1.21,4.036,1.29c1.589,0.519,2.386,0.603,3.031-0.521 c0.523-0.893,0.572-0.976,1.063-2.067c0.252-0.553,0.434-1.03,0.789-0.991C140.951,220.486,140.48,219.662,140.382,219.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M131.489,210.776c-6.082,2.442-4.248,11.52-0.105,11.971c0.481,0.053,0.073-0.685,0.159-1.457 c0.034-0.336,0.175-0.188-0.411-0.998c-1.063-1.477-0.212-2.317,0.115-2.282c0.607,0.066,0.567,1.22,1.95-1.035 c0.895-1.457,1.559-1.856,3.803-1.646c1.407,0.131,2.634-0.286,3.332-0.741C141.347,213.931,137.739,208.265,131.489,210.776z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 157.762,
    y: 242.67,
    transform: "matrix(0.301 -0.9536 0.9536 0.301 -118.5498 324.7604)",
    style: {
      fill: "#1B62A9"
    },
    width: 9.011,
    height: 1.163
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M128.5,231.807c1.263-0.801,2.944-0.422,3.745,0.847l11.965,19.979l12.887-5.12 c0.819-0.283,1.737,0.084,2.13,0.883c0.425,0.865-0.205,0.89-1.071,1.311l-13.895,7.939c-1.143,0.554-2.561,0.177-3.252-0.924 l-0.088-0.138l-13.271-21.027C126.848,234.287,127.228,232.607,128.5,231.807z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF405C"
    },
    d: "M130.105,241.547l-2.83-5.894c-0.865-1.495-0.354-3.408,1.145-4.273 c1.492-0.864,3.408-0.353,4.271,1.143l3.842,5.633L130.105,241.547z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M157.203,247.34l-0.522,0.291l1.229,2.211l0.533-0.296c0.726,0.172,2.457-0.421,3.232-1.094 c1.221-1.058,1.549-2.735,0.887-3.325c-0.673-0.602-1.727-0.095-2.863,0.814c-0.186,0.154-0.407,0.177-0.273-0.144 c0.271-0.643,0.256-1.025,0.049-1.111C159.163,244.564,157.625,245.973,157.203,247.34z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M129.393,212.149c0,0-3.893-2.371-7.559,0.937c-4.036,3.639-1.905,9.627,0.283,11.903 c2.677,2.785,1.889,8.545,0.688,10.552c-1.201,2.009,2.118,3.153,2.925,0.631c0.809-2.52,2.184-9.422,1.452-11.371 c-0.729-1.947-2.413-12.097,1.512-11.67L129.393,212.149z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M160.611,108.547c-3.27-9.354,1.094-22.292-1.961-32.954c-0.51-1.782-1.494-3.45-3.119-3.942 c-1.43-0.432-3.088-0.974-4.035-0.974c-2.094,0-3.552,1.684-6.186,5.345c-3.888,5.397-4.297,21.494-4.331,32.525H160.611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M151.544,65.48v5.379c0,1.035,1.901,1.868,2.877,1.868c0.669,0,1.048-0.365,1.048-1.868v-4.395 L151.544,65.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M159.139,62.947c-0.334-0.651-0.484-1.384-0.543-2.051c0.004-0.039,0.006-0.065,0.006-0.065 c0.096-0.872,0.766-2.192,0.537-2.822c-0.596-1.635-2.949-2.543-5.23-2.79c-2.887-0.314-5.061,1.528-5.51,5.663 c-0.232,2.14,1.102,4.448,2.619,4.892c1.146,0.331,3.352,1.067,3.559,1.137c1.405,0.456,2.107,0.531,2.676-0.458 c0.464-0.789,0.506-0.861,0.936-1.822c0.224-0.489,0.385-0.91,0.697-0.877C159.638,63.835,159.221,63.107,159.139,62.947z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 174.464,
    y: 83.399,
    transform: "matrix(0.3002 -0.9539 0.9539 0.3002 44.8265 228.927)",
    style: {
      fill: "#1B62A9"
    },
    width: 7.948,
    height: 1.027
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M148.656,73.819c1.115-0.705,2.598-0.374,3.305,0.746l10.551,17.62l11.365-4.518 c0.724-0.248,1.534,0.075,1.879,0.781c0.375,0.762-0.182,0.784-0.943,1.155l-12.257,7c-1.007,0.489-2.258,0.156-2.868-0.814 l-0.074-0.121l-11.709-18.545C147.201,76.006,147.535,74.525,148.656,73.819z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M150.072,82.409l-2.496-5.198c-0.761-1.318-0.311-3.005,1.009-3.768 c1.317-0.763,3.007-0.313,3.767,1.006l3.389,4.968L150.072,82.409z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M173.971,87.518l-0.461,0.257l1.086,1.949l0.467-0.26c0.641,0.151,2.17-0.372,2.855-0.967 c1.071-0.931,1.36-2.411,0.779-2.932c-0.595-0.529-1.524-0.083-2.525,0.719c-0.162,0.136-0.36,0.155-0.24-0.127 c0.24-0.567,0.224-0.904,0.043-0.98C175.699,85.068,174.346,86.312,173.971,87.518z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#133D7A"
    },
    points: "159.595,108.063 202.586,115.176 202.586,118.908 153.824,119.057  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M193.309,119.057c2.316-0.729,1.553-3.239,0.721-3.251c-0.613-0.006-1.332-0.02-2.215-0.02 c-1.297,0-2.221-0.603-2.139-0.603h-3.643c-0.091,0.072-0.174,0.214-0.219,0.459l-0.02,3.414H193.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M206.457,111.544c-0.73-2.32-3.24-1.556-3.25-0.721c-0.008,0.612-0.021,1.332-0.021,2.212 c0,1.297-0.6,2.224-0.6,2.141v3.641c0.072,0.092,0.213,0.174,0.455,0.221l3.416,0.02V111.544z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#175594"
    },
    d: "M190.699,115.43c-1.977-6.512-5.342-23.446-8.15-24.137c-6.772-1.667-22.188,15.808-22.188,15.808 l-19.259,0.191c0,0-1.768,11.633,2.894,11.633c0,0,12.037,0.55,16.874-0.146c4.61-0.661,18.858-17.138,18.858-17.138l5.8,13.816 L190.699,115.43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M144.426,79.833c0.742,1.504,6.465,1.229,7.494-0.094c2.892-3.724-0.594-5.811,0.436-7.721 c1.468-2.718,1.871-7.326,0.556-10.391c-0.258-0.464-0.48-1.055-0.135-1.167c0.501-0.164,0.831,0.211,0.943,0.733 c0.018,0.083,0.026,0.271,0.291,0.262c0.096-0.003,0.216,0.002,0.33,0.005c0.271,0.011,0.256-0.154,0.359-0.695 c0.053-0.241,0.514-2.679,1.599-2.661c1.237,0.021,2.498,0.437,2.798,0.539c0.848,0.254,0.843-1.959,0.146-2.343 c-1.234-0.684-2.029-1.815-5.068-2.108c-1.443-0.138-2.76,0.26-3.72,1.045c0-0.005,0-0.005,0-0.009c0,0-0.008,0.009-0.017,0.023 c-0.887,0.729-2.4,3.542-2.563,5.602c-0.346,4.447-2.379,5.375-2.615,10.038C145.148,73.077,141.74,74.411,144.426,79.833z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D9AD6"
    },
    d: "M285.142,76.118c0-2.646-0.753-3.521-5.196-3.521c-0.695,0-3.6,0-3.6,0h-2.566 c0,0-3.635,0-4.328,0c-1.94,0-2.846,0.752-3.474,3.351l-0.753,33.574h19.917V76.118z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D55A0"
    },
    d: "M265.99,109.521v3.962c0,1.848,1.496,3.345,3.345,3.345h11.464c1.848,0,3.344-1.497,3.344-3.345 v-3.962H265.99z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M281.49,63.396c0,3.279-2.813,5.525-5.697,5.525c-2.773,0-5.696-2.322-5.696-5.651v-2.973 c0-3.128,2.553-4.568,5.697-4.568l0,0c3.151,0,5.696,1.44,5.696,4.568V63.396z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M277.996,73.297c0,0-0.461,1.163-2.236,1.163c-2.049,0-2.232-1.163-2.232-1.163v-7.069h4.469 V73.297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M275.731,54.35c-3.019,0-4.682,2.417-4.682,2.417c-0.462,0.846-3.084,0.06-3.084,0.06 c0.06,1.313,0.282,2.708,1.925,3.462v0.6v2.735v0.312c0,0,0.005-0.001,0.016-0.006c0.166,3.08,2.795,5.531,6.023,5.531 c3.202,0,5.815-2.41,6.02-5.455c0.013-0.008,0.019-0.012,0.019-0.012v-0.37v-1.327v-2.227 C281.968,56.861,278.752,54.35,275.731,54.35z M275.956,68.228c-1.243,0-3.106-0.557-3.106-1.252 c0-0.372,1.664-1.314,3.085-1.314c1.897,0,3.184,0.977,3.184,1.396C279.118,67.639,277.682,68.228,275.956,68.228z  M280.077,65.339c-0.011,0.228-0.339,0.546-0.743,0.288c-1.385-0.882-4.138-1.814-6.965,0.077 c-0.461,0.309-0.89-0.223-0.989-0.555c-0.144-0.463-0.218-0.971-0.218-1.517c-0.005-0.986-0.017-2.711-0.017-2.711h-0.017 c0.006-0.079,0.01-0.164,0.014-0.248c0.588,0.116,1.021,0.181,1.846,0.181c2.483,0,4.766-2.443,6.029-2.03 c0.605,0.2,1.063,0.942,1.063,1.571c0,0.294,0,1.729,0,2.629c0,0.324,0,0.581,0,0.688 C280.08,64.218,280.077,65.283,280.077,65.339z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M291.5,92.875l-5.203-17.49c-0.537-1.708-2.272-2.223-3.536-1.868 c-1.261,0.355-2.442,1.919-1.94,3.523l5.814,15.835H291.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0088CC"
    },
    d: "M288.427,81.104l-2.005-6.098c-0.531-1.612-2.267-2.489-3.881-1.959 c-1.611,0.529-2.486,2.268-1.959,3.88l2.006,6.097L288.427,81.104z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M286.635,92.875l-10.841,5.544l0.924,3.593c0,0,16.015-4.447,14.782-9.137l-2.527-0.282 L286.635,92.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M259.26,92.875l5.203-17.49c0.537-1.708,2.273-2.223,3.537-1.868 c1.262,0.355,2.443,1.919,1.939,3.523l-5.813,15.835H259.26z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0088CC"
    },
    d: "M262.334,81.104l2.006-6.098c0.529-1.612,2.266-2.489,3.879-1.959 c1.611,0.529,2.488,2.268,1.961,3.88l-2.009,6.097L262.334,81.104z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M264.126,92.875l10.84,5.544l-0.923,3.593c0,0-16.014-4.447-14.783-9.137l2.527-0.282 L264.126,92.875z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M287,108.438c0,0.566-0.461,1.026-1.027,1.026h-21.102c-0.568,0-1.027-0.46-1.027-1.026v-15.64 c0-0.566,0.459-1.026,1.027-1.026h21.102c0.566,0,1.027,0.46,1.027,1.026V108.438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#433D3B"
    },
    d: "M289.067,111.251c0,0.454-0.368,0.821-0.821,0.821h-25.203c-0.452,0-0.82-0.367-0.82-0.821 v-0.965c0-0.454,0.368-0.822,0.82-0.822h25.203c0.453,0,0.821,0.368,0.821,0.822V111.251z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1D9AD6"
    },
    d: "M279.158,114.104c0,0,2.863,0.197,3.818,0.191c3.113-0.017,4.962-0.085,4.962-0.085 c1.337,0,2.399,0.976,2.399,2.314c0,1.337-1.085,2.422-2.424,2.422h-8.756V114.104z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M281.744,118.947l1.039-4.843l-20.681-8.982c-2.018-0.632-4.929-1.798-6.674,1.548 c-0.979,1.871-1.294,4.939,2.667,6.179l17.988,6.099H281.744z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0088CC"
    },
    d: "M268.316,114.457c0,0-6.563-0.153-8.758-0.353c-1.33-0.122-2.42,1.082-2.42,2.421 c0,1.337,1.083,2.422,2.42,2.422h8.758V114.457z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M289.789,110.376l-22.736,3.408v5.163h24.252c4.147,0,4.766-3.023,4.39-5.102 C295.024,110.132,291.9,110.376,289.789,110.376z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M326.969,345.675c-2.832-0.89-1.895-3.955-0.878-3.969c0.751-0.008,1.631-0.025,2.702-0.025 c1.583,0,2.722-0.735,2.616-0.735h4.453c0.103,0.09,0.207,0.262,0.263,0.561l0.016,4.169H326.969z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M326.839,279.67h11.838c-1.734,4.888-2.79,55.729-2.79,61.275h-4.477 C331.409,340.945,326.839,285.663,326.839,279.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M337.445,345.675c-2.834-0.89-1.899-3.955-0.881-3.969c0.747-0.008,1.626-0.025,2.7-0.025 c1.584,0,2.718-0.735,2.617-0.735h4.444c0.112,0.09,0.215,0.262,0.271,0.561l0.021,4.169H337.445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M337.308,279.67h11.842c0,5.009-2.788,55.729-2.788,61.275h-4.479 C341.882,340.945,340.071,286.49,337.308,279.67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M327.275,314.02c-1.182-14.991-0.436-31.253-0.436-34.35h11.838 c-0.63,3.935-0.994,18.001-0.802,34.35H327.275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M338.929,314.02c-1.065-14.991-0.252-28.303-1.621-34.35h11.842c0,2.738,0.55,18.874,0,34.086 L338.929,314.02z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F0516F"
    },
    d: "M326.311,280.46c1.117-15.781,1.027-29.675,4.991-39.629c0.777-1.941,1.761-3.632,3.595-4.187 c1.614-0.488,2.263-0.413,4.316-1.352c0,0,2.621-0.44,5.574,3.681c4.031,5.626,5.447,20.208,5.109,41.487H326.311z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.945,
    y: 248.272,
    transform: "matrix(0.9542 -0.299 0.299 0.9542 -61.5701 103.5371)",
    style: {
      fill: "#1B62A9"
    },
    width: 1.213,
    height: 9.388
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M342.735,241.043c-1.321-0.835-3.067-0.441-3.906,0.882l-12.463,20.814l-13.428-5.334 c-0.854-0.296-1.809,0.087-2.217,0.92c-0.441,0.901,0.213,0.926,1.113,1.365l14.479,8.272c1.189,0.577,2.666,0.184,3.386-0.963 l0.093-0.143l13.828-21.907C344.454,243.626,344.06,241.878,342.735,241.043z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF405C"
    },
    d: "M341.061,251.19l2.948-6.141c0.901-1.558,0.368-3.551-1.192-4.451 c-1.557-0.901-3.553-0.369-4.451,1.189l-4.003,5.869L341.061,251.19z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M339.556,229.775v6.132c0,1.185-2.302,2.148-3.486,2.148c-0.809,0-1.268-0.418-1.268-2.148v-6.132 H339.556z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M330.237,226.78c0.376-0.793,0.537-1.68,0.585-2.484c-0.006-0.047-0.011-0.078-0.011-0.078 c-0.141-1.045-0.988-2.608-0.726-3.376c0.66-1.981,3.464-3.147,6.19-3.515c3.469-0.469,6.14,1.682,6.808,6.638 c0.346,2.566-1.195,5.382-2.999,5.959c-1.369,0.437-4.001,1.389-4.251,1.478c-1.668,0.594-2.508,0.703-3.227-0.468 c-0.574-0.934-0.63-1.02-1.182-2.163c-0.284-0.579-0.493-1.081-0.864-1.031C329.664,227.86,330.139,226.976,330.237,226.78z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M332.776,216.875c1.574-0.646,5.161-1.712,8.109,0.68c4.462,3.62,3.219,9.453,2.201,11.057 c-0.91,1.435-3.154,1.604-3.184,1.37c-0.068-0.515-0.098-0.725-0.209-1.543c-0.047-0.354-0.188-0.192,0.404-1.07 c1.094-1.599,0.168-2.472-0.178-2.425c-0.646,0.087-0.572,1.313-2.103-1.046c-0.99-1.525-1.707-1.931-4.082-1.646 c-1.498,0.178-2.709-0.462-3.561-0.696C326.353,220.51,330.018,218.016,332.776,216.875z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M312.827,257.226l0.549,0.303l-1.283,2.304l-0.555-0.307c-0.757,0.178-2.561-0.439-3.37-1.143 c-1.27-1.101-1.611-2.85-0.923-3.463c0.702-0.627,1.801-0.099,2.984,0.849c0.192,0.161,0.423,0.186,0.284-0.15 c-0.283-0.669-0.266-1.067-0.051-1.156C310.787,254.332,312.39,255.801,312.827,257.226z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.572,
    y: 234.884,
    style: {
      fill: "#FAA74A"
    },
    width: 1.359,
    height: 3.516
  }), /*#__PURE__*/React.createElement("rect", {
    x: 90.628,
    y: 234.884,
    style: {
      fill: "#FAA74A"
    },
    width: 1.362,
    height: 3.516
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC450"
    },
    points: "90.628,234.884 98.932,234.884 97.439,233.499 91.899,233.499  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC450"
    },
    points: "84.373,256.345 105.285,256.345 103.421,237.839 86.24,237.839  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FAA74A"
    },
    points: "83.468,258.99 106.354,258.99 105.285,256.345 84.373,256.345  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M83.746,173.523v6.273c0,1.213-2.354,2.197-3.567,2.197c-0.827,0-1.298-0.427-1.298-2.197v-6.273 H83.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M74.556,169.321c0.472-0.724,0.745-1.57,0.897-2.349c0-0.049,0-0.079,0-0.079 c0-1.039-0.621-2.679-0.262-3.395c0.907-1.85,3.8-2.618,6.512-2.618c3.453,0,5.776,2.452,5.776,7.384 c0,2.554-1.877,5.102-3.714,5.429c-1.396,0.246-4.094,0.828-4.352,0.883c-1.709,0.36-2.543,0.356-3.093-0.883 c-0.436-0.987-0.479-1.079-0.868-2.269c-0.199-0.605-0.336-1.122-0.707-1.122C73.852,170.303,74.434,169.5,74.556,169.321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M77.851,159.869c2.738-0.668,6.007-1.471,8.578,1.251c4.602,4.873,2.257,10.343,1.051,11.774 c-1.079,1.285-3.9,1.063-3.9,0.832c0-0.514,0-0.724,0-1.537c0-0.352-0.16-0.213,0.536-0.992c1.279-1.418,0.49-2.394,0.146-2.394 c-0.642,0-0.577,1.045-1.763-1.463c-0.766-1.621-1.414-2.112-3.772-2.146c-1.485-0.022-2.825-0.486-3.545-0.985 c-1.279-0.89-1.429-4.439-1.429-4.439C74.488,160.529,76.096,160.297,77.851,159.869z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M53.182,217.843l0.557-0.31l1.314,2.356l-0.567,0.314c-0.255,0.755-1.763,1.991-2.808,2.314 c-1.643,0.513-3.348-0.134-3.51-1.063c-0.166-0.949,0.883-1.618,2.347-2.139c0.241-0.08,0.388-0.268,0.021-0.326 c-0.734-0.116-1.069-0.348-1.031-0.582C49.564,218.059,51.705,217.458,53.182,217.843z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M91.791,230.248l-0.146-0.621l2.627-0.608l0.148,0.631c0.652,0.453,1.422,2.246,1.443,3.341 c0.037,1.72-1.058,3.179-1.995,3.077c-0.959-0.104-1.31-1.299-1.404-2.848c-0.009-0.256-0.147-0.448-0.306-0.112 c-0.316,0.673-0.633,0.934-0.846,0.83C90.992,233.781,91.006,231.559,91.791,230.248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M92.7,189.705l2.211,39.602l-3.64,1.084C91.271,230.391,89.295,200.99,92.7,189.705z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.715,288.676c0.494-0.544,1.153-1.268,1.789-1.969c1.006-1.112,1.156-2.697,1.156-2.697 l2.883-2.805c0,0,0.498-0.191,0.939,0.248c0.879,0.869,2.88,2.614,2.88,2.614s-4.4,4.868-4.866,5.384 C100.166,293.122,97.916,289.553,98.715,288.676z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M92.229,260.713c-0.818-2.064-1.445-36.878-1.445-36.878H79.834c0,0-0.086,25.141,5.217,39.04 c0.885,2.328,14.734,19.298,16.609,21.135l2.907-2.813C101.74,278.1,93.867,264.83,92.229,260.713z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M70.16,293.705c-2.588-0.789-1.73-3.514-0.798-3.524c0.685-0.008,1.485-0.02,2.462-0.021 c1.338-0.004,1.571-0.6,1.668-0.655h4.799c0.095,0.081,0.189,0.233,0.247,0.499l0.016,3.702H70.16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M69.96,223.835h11.165c0,5.195-4.018,35.085-4.018,37.667c0,3.604,1.176,22.249,1.176,28.002 h-4.791c0,0-4.887-25.314-4.887-28.668C68.605,255.881,69.96,230.055,69.96,223.835z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M71.279,187.216c1.057-6.815,6.14-7.355,8.072-7.355c1.076,0,3.23,0,4.307,0 c6.605,0,9.185,8.146,9.185,11.373c0,8.543-0.019,32.98-0.019,32.98l-24.926-0.011C67.898,224.202,69.856,196.395,71.279,187.216 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M52.956,216.774c16.972-8.257,18.503-30.52,18.52-30.729c0.146-1.806,1.717-3.154,3.532-3.014 c1.813,0.142,3.163,1.724,3.018,3.533c-0.078,1.003-2.723,24.547-23.041,34.43L52.956,216.774z"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 369.197,
    y: 241.139,
    style: {
      fill: "#FAA74A"
    },
    width: 1.123,
    height: 2.908
  }), /*#__PURE__*/React.createElement("rect", {
    x: 374.939,
    y: 241.139,
    style: {
      fill: "#FAA74A"
    },
    width: 1.125,
    height: 2.908
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEC450"
    },
    points: "376.064,241.139 369.197,241.139 370.432,239.993 375.014,239.993  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0516F"
    },
    points: "381.24,258.892 363.939,258.892 365.484,243.582 379.697,243.582  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D9465F"
    },
    points: "381.99,261.08 363.055,261.08 363.939,258.892 381.24,258.892  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M385.262,180.29v5.704c0,1.097,2.016,1.982,3.05,1.982c0.709,0,1.113-0.387,1.113-1.982v-4.66 L385.262,180.29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M393.448,176.866c-0.427-0.648-0.671-1.403-0.805-2.1c0-0.042,0-0.071,0-0.071 c0-0.929,0.554-2.396,0.237-3.036c-0.814-1.656-3.4-2.341-5.834-2.341c-3.08,0-5.158,2.192-5.158,6.604 c0,2.283,1.674,4.561,3.321,4.856c1.247,0.218,3.659,0.74,3.887,0.789c1.532,0.321,2.28,0.318,2.767-0.789 c0.396-0.886,0.434-0.967,0.78-2.03c0.177-0.541,0.298-1.004,0.631-1.004C394.075,177.744,393.554,177.025,393.448,176.866z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M407.834,235.814c-0.299-0.578-8.25-14.56-9.853-19.276 c-6.966-20.514-9.681-24.695-9.696-24.748c-0.596-1.536,0.166-3.265,1.703-3.86c1.541-0.596,3.267,0.166,3.865,1.703 c0.082,0.206,2.281,5.534,8.215,26.056c1.043,3.606,6.305,14.994,8.302,18.821L407.834,235.814z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB84E"
    },
    d: "M395.471,202.177c0.93-0.492,1.864-0.948,2.824-1.373c-2.896-8.458-4.387-11.028-4.441-11.172 c-0.598-1.537-2.324-2.299-3.865-1.703c-1.537,0.596-2.299,2.324-1.703,3.86c0.012,0.038,1.029,2.684,4.16,11.703 C393.505,203.183,394.496,202.69,395.471,202.177z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#1B62A9"
    },
    d: "M404.155,252.904c-0.067-0.731-5.438-20.112-7.276-25.729h-18.9c0,0,2.664,27.602,2.582,28.002 c-0.101,0.554-11.355,26.039-14.248,29.206l3.02,3.59c1.914-1.878,5.125-3.943,6.539-6.115 c1.408-2.178,11.838-17.697,13.459-24.493c1.33-5.557-0.604-22.85-0.604-22.85c1.709,2.855,2.305,5.438,3.342,9.001 c0.625,2.149,3.416,12.184,3.487,12.605c0.034,0.208,1.327,29.246,1.327,34.294h5.15c0.568-5.641,2.189-36.359,2.189-36.359 C404.215,253.645,404.185,253.27,404.155,252.904z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB84E"
    },
    d: "M399.983,234.201c-2.502-11.828-4.428-13.665-4.428-19.159v-5.75 c0-2.286,1.348-7.605,1.368-9.842c0.055-5.725-4.008-12.517-7.292-12.517h-4.692c-4.546,0-5.317,7.41-5.317,10.343 c0,3.544-1.013,9.927-1.013,16.949c0,7.246-1.098,11.13-1.785,19.976H399.983z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M383.488,187.174c-7.093,0-10.6,9.756-12.278,29.339c-0.41,4.801,0.229,18.376,0.214,19.167 h2.853c-0.056-1.384,0.808-14.762,1.185-19.167c1.662-19.397,6.621-23.369,8.027-23.369c1.645,0,2.986-1.334,2.986-2.983 C386.475,188.511,385.134,187.174,383.488,187.174z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB84E"
    },
    d: "M383.488,187.174c-4.916,0-8.686,4.58-10.967,13.901l6.251,2.152 c1.833-7.742,3.739-10.084,4.716-10.084c1.645,0,2.986-1.334,2.986-2.983C386.475,188.511,385.134,187.174,383.488,187.174z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2C2825"
    },
    d: "M391.217,169.452c-0.955-0.621-3.875-2.749-7.537-0.604c-3.201,1.874-2.938,3.652-5.103,7.205 c-1.533,2.517-1.486,6.882-0.033,11.923c0.645,2.238,1.65,4.967,0.813,9.279c-0.834,4.309-2.089,7.175-0.355,8.905 c1.727,1.73,1.954,2.985,1.668,4.479c-1.336,6.988,9.44,5.629,6.984,0.298c-1.371-2.984,0.969-4.469,0.43-6.686 c-1.332-5.494,1.4-8.537,0.5-10.628c-1.058-2.439-2.113-5.258-1.109-6.507c0.857-1.066,0.609-2.654-0.874-5.006l-0.022-0.66 c0,0,0.012,0,0.022,0c0-2.082-0.093-2.753-0.093-2.753s-0.063-1.131-0.43-1.155c-0.467-0.029-0.771-0.167-0.972-0.349 c-0.481-0.883,0.007-1.426,0.243-1.457c0.89-0.119,1.176,1.089,1.176,1.089c0,0.201,0.684,0.313,0.684,0.012 c0-1.345,1.681-1.996,2.016-3.2c0.602-2.157,3.767-1.276,3.767-1.276C393.357,170.975,391.953,169.933,391.217,169.452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB84E"
    },
    d: "M405.742,294.861c2.661-0.834,1.779-3.721,0.824-3.731c-0.705-0.01-1.533-0.023-2.543-0.023 c-1.492,0-2.555-0.692-2.457-0.692h-4.183c-0.104,0.084-0.2,0.245-0.255,0.527l-0.016,3.919H405.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FDB84E"
    },
    d: "M368.432,293.868c2.346,1.508,3.996-1.019,3.391-1.76c-0.445-0.546-0.963-1.19-1.607-1.966 c-0.959-1.147-1.107-2.404-1.047-2.332l-2.678-3.209c-0.132-0.026-0.316,0.004-0.568,0.142l-3.021,2.5L368.432,293.868z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M407.705,235.642l-0.31-0.603l2.532-1.308l0.318,0.611c0.787,0.298,2.047,1.936,2.361,3.054 c0.492,1.758-0.244,3.539-1.232,3.679c-1.005,0.142-1.684-0.992-2.186-2.56c-0.08-0.258-0.273-0.419-0.344-0.033 c-0.145,0.771-0.402,1.118-0.646,1.068C407.834,239.475,407.258,237.189,407.705,235.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F58C8B"
    },
    d: "M374.268,236.25l0.009-0.677l-2.849-0.052l-0.016,0.689c-0.572,0.616-0.975,2.643-0.762,3.785 c0.337,1.793,1.783,3.063,2.732,2.752c0.965-0.318,1.072-1.636,0.826-3.264c-0.043-0.266,0.06-0.497,0.297-0.183 c0.467,0.627,0.852,0.825,1.047,0.673C375.848,239.743,375.353,237.438,374.268,236.25z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcommerceRetail);
export default __webpack_public_path__ + "static/media/ecommerce-retail.e709fc1f3a768a06301dbbddf4de971e.svg";
export { ForwardRef as ReactComponent };